import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import ModalSkeleton from "../../../components/ModalSkeleton";
import ModalAction from "../../../components/ModalAction";
import PreviewImagePicker from "../../../components/preview-picker";
import classes from "./AddOrEditBanner.module.css";

// Validation schema
const bannerSchema = Yup.object().shape({
  bannerImage: Yup.string().required("Banner image is required"),
});

// Initial values
const initialValues = {
  bannerImage: null,
};

const AddOrEditBanner = ({
  show,
  setShow,
  onSubmit,
  isApiCall = false,
  data,
}) => {
  // Initialize formik
  const formik = useFormik({
    initialValues: data || initialValues,
    validationSchema: bannerSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (typeof onSubmit === "function") {
        const params = {
          images:[ {
            courtId: null,
            companyImage: values.bannerImage,
            companyImageTypeId: 4,
          },
        ],
        };

        console.log("Params", params);
        onSubmit(params);
        resetForm();
        setShow(false);
      }
   
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    resetForm,
  } = formik;

  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      title={data ? "Edit Banner" : "Add Banner"}
      width="700px"
    >
      <form onSubmit={handleSubmit}>
        <Row className={classes.controlGrid}>
          <Col xs={12}>
            <PreviewImagePicker
              label="Banner Image"
              name="bannerImage"
              value={values?.bannerImage}
              onChange={(image) => {
                setFieldValue("bannerImage", image);
                
              }}
              errorText={touched?.bannerImage && errors?.bannerImage}
            />
          </Col>
        </Row>
        <div className={classes.instructions}>
          <p>
            Please upload a banner image. Recommended size: 1200x300 pixels.
          </p>
        </div>
        <ModalAction
          isApiCall={isApiCall}
          onCancel={() => {
            resetForm();
            // if (typeof setShow === "function") {
            //   setShow(false);
            // }
          }}
          type="submit"
        />
      </form>
    </ModalSkeleton>
  );
};

export default AddOrEditBanner;
